import { ActivityFeedFragment } from 'services/apollo';
import gql from 'graphql-tag';

export const CompareHomeActivityFeedQuery = gql`
  query getCompareHomeActivityFeed(
    $first: Int!
    $cursor: String!
    $includeGroups: Boolean!
    $customIdentifier: String!
  ) {
    me {
      activityFeed(
        first: $first
        cursor: $cursor
        includeGroups: $includeGroups
        customIdentifier: $customIdentifier
      ) {
        id: customIdentifier
        ...activityFeedResults
      }
    }
  }
  ${ActivityFeedFragment}
`;
